// Starter prompts for the Mia welcome card. The strings live in presetPrompts.json so the backend
// guardrail regression test can exercise the exact text we ship — a first-party preset getting
// blocked by the content filter is a release-blocking bug, and it has happened in production.
import presets from './presetPrompts.json';

export interface PresetPrompt {
  label: string;
  prompt: string;
}

type PresetGroup = keyof Omit<typeof presets, '_comment'>;

type Vars = Partial<Record<'dealer' | 'vehicle' | 'vin' | 'priority' | 'tier' | 'band', string>>;

function fill(text: string, vars: Vars): string {
  return text.replace(/\{(dealer|vehicle|vin|priority|tier|band)\}/g, (_m, key: keyof Vars) => vars[key] ?? '');
}

/** Resolve a preset group, substituting any {placeholders}. */
export function presetPrompts(group: PresetGroup, vars: Vars = {}): PresetPrompt[] {
  return (presets[group] as PresetPrompt[]).map((p) => ({
    label: fill(p.label, vars),
    prompt: fill(p.prompt, vars),
  }));
}

/** Every shipped prompt template, for tests. */
export function allPresetPrompts(): PresetPrompt[] {
  return (Object.entries(presets) as [string, unknown][])
    .filter(([key]) => key !== '_comment')
    .flatMap(([, group]) => group as PresetPrompt[]);
}
